import { createFileRoute, redirect } from '@tanstack/react-router';
import { useFeatures } from '@/hooks/useFeatures';
import { ensurePermissions } from '@/hooks/usePermissions';
import { CreateOrderPage } from '../-components/CreateOrderPage';

export const Route = createFileRoute('/(client)/orders-hub/(pages)/create')({
  beforeLoad: async () => {
    // The same cache entry the page's own hook reads, so the guard and the
    // screen cannot disagree and the check costs no second request.
    const { orders } = await ensurePermissions();
    if (!orders.canRead) throw redirect({ to: '/dashboard' });
    if (!orders.canCreate) throw redirect({ to: '/orders-hub' });
  },
  component: CreateOrderRoute,
});

function CreateOrderRoute() {
  const { isOrdersHubEnabled } = useFeatures();
  if (!isOrdersHubEnabled) return null;
  return <CreateOrderPage />;
}
